/**
 * @generated SignedSource<<f0f2e6ce3598c84f9b9870fae55a1d5a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BrowseDepartmentSection$data = {
  readonly department: {
    readonly " $fragmentSpreads": FragmentRefs<"BrowsePeopleFieldSection">;
  } | null;
  readonly " $fragmentType": "BrowseDepartmentSection";
};
export type BrowseDepartmentSection$key = {
  readonly " $data"?: BrowseDepartmentSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"BrowseDepartmentSection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "workspaceId"
    }
  ],
  "kind": "Fragment",
  "name": "BrowseDepartmentSection",
  "selections": [
    {
      "alias": "department",
      "args": [
        {
          "kind": "Variable",
          "name": "after",
          "variableName": "after"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        },
        {
          "kind": "Literal",
          "name": "peopleFieldType",
          "value": "DEPARTMENT"
        },
        {
          "kind": "Variable",
          "name": "workspaceId",
          "variableName": "workspaceId"
        }
      ],
      "concreteType": "PeopleFieldAggregateResponse",
      "kind": "LinkedField",
      "name": "peopleFieldAggregates",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "BrowsePeopleFieldSection"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "d6ed17cdf9fbab5178f5ec022837bbd6";

export default node;
